<template>
    <div class="auth-wrapper">

        <!-- LEFT: Brand Panel -->
        <div class="auth-brand">
            <router-link to="/" class="nav-logo">
                <img src="@/assets/white_logo.svg" alt="Succour Logo" class="logo-img">
            </router-link>
            <div class="brand-body">
                <h2>Care that <em>feels like</em> family.</h2>
                <p>Join thousands of Nigerian families and caregivers on the platform built around trust, safety and
                    compassion.</p>
            </div>
            <div class="brand-features">
                <div class="brand-feat">
                    <div class="brand-feat-icon">🛡️</div><span>Every Care Giver is fully verified</span>
                </div>
                <div class="brand-feat">
                    <div class="brand-feat-icon">🤝</div><span>Smart matching built around your needs</span>
                </div>
                <div class="brand-feat">
                    <div class="brand-feat-icon">📍</div><span>Active across Nigerian states</span>
                </div>
            </div>
        </div>

        <!-- RIGHT: Form Panel -->
        <div class="auth-form-panel">
            <div class="auth-form-inner">

                <!-- Back to site -->
                <router-link to="/" class="back-link">← Back to site</router-link>
                <ToastManagerVue ref="toastManager" />

                <!-- User type toggle -->
                <div class="user-toggle"
                    v-if="currentScreen !== 'forgot' && currentScreen !== 'forgot-success' && currentScreen !== 'verify' && currentScreen !== 'reset' && currentScreen !== 'reset-success'">
                    <button class="toggle-btn" :class="{ active: userType === 'seeker' }"
                        @click="setUserType('seeker')">
                        Care Seeker
                    </button>

                    <button class="toggle-btn" :class="{ active: userType === 'giver' }" @click="setUserType('giver')">
                        Care Giver
                    </button>
                </div>



                <!-- ── SCREEN: LOG IN ── -->
                <div class="auth-screen" v-show="currentScreen === 'login'">
                    <h2 class="auth-title">{{ currentTitle }}</h2>
                    <p class="auth-subtitle">{{ currentSub }}</p>

                    <div class="form-group">
                        <label>Email Address <span class="required">*</span></label>
                        <input type="email" v-model="login.email" placeholder="you@example.com" />
                    </div>

                    <div class="form-group password-wrap">
                        <label>Password <span class="required">*</span></label>
                        <input :type="showPw.login ? 'text' : 'password'" v-model="login.password"
                            placeholder="Enter your password" />
                        <button class="eye-btn" @click="togglePw('login')" type="button">
                            {{ showPw.login ? '🙈' : '👁' }}
                        </button>
                    </div>

                    <div class="forgot-link">
                        <a href="#" class="auth-link" @click.prevent="showScreen('forgot')">Forgot password?</a>
                    </div>

                    <button class="btn-auth green" @click="handleLogin" :disabled="isLoggingIn">
                        {{ isLoggingIn ? "Logging in..." : "Sign In" }}
                    </button>

                    <!-- <div class="or-divider">or</div>

                    <button class="btn-google" @click="handleGoogle()">
                        <svg width="18" height="18" viewBox="0 0 24 24">
                            <path fill="#4285F4"
                                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                            <path fill="#34A853"
                                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                            <path fill="#FBBC05"
                                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
                            <path fill="#EA4335"
                                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                        </svg>
                        Continue with Google
                    </button> -->

                    <p class="auth-footer-text">
                        Don't have an account?
                        <a href="#" class="auth-link" @click.prevent="showScreen('signup')">Create one</a>
                    </p>
                </div>

                <!-- ── SCREEN: SIGN UP ── -->
                <div class="auth-screen" v-show="currentScreen === 'signup'">
                    <h2 class="auth-title">{{ currentTitle }}</h2>
                    <p class="auth-subtitle">{{ currentSub }}</p>

                    <div class="form-row">
                        <div class="form-group">
                            <label>First Name <span class="required">*</span></label>
                            <input type="text" id="signup-first" v-model="signup.first_name" placeholder="Adaeze" />
                        </div>
                        <div class="form-group">
                            <label>Last Name <span class="required">*</span></label>
                            <input type="text" id="signup-last" v-model="signup.last_name" placeholder="Okonkwo" />
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Email Address <span class="required">*</span></label>
                        <input type="email" id="signup-email" v-model="signup.email" placeholder="you@example.com" />
                    </div>

                    <div class="form-group">
                        <label>Phone Number <span class="required">*</span></label>
                        <input type="tel" id="signup-phone" v-model="signup.phone" placeholder="0800 000 0000" />
                    </div>

                    <div class="form-group">
                        <label>State <span class="required">*</span></label>
                        <select id="signup-state" v-model="signup.state">
                            <option value="" disabled selected>Select your state</option>
                            <option v-for="state in states" :key="state.alias" :value="state.state">
                                {{ state.state }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Date of Birth <span class="required">*</span></label>
                        <input type="date" v-model="signup.date_of_birth" placeholder="Select your date of birth" />
                        <span v-if="signup.date_of_birth && !isValidDate(signup.date_of_birth)" class="error-text">
                            You must be at least 18 years old
                        </span>
                    </div>

                    <div class="form-group password-wrap">
                        <label>Password <span class="required">*</span></label>
                        <input :type="showPw.signup ? 'text' : 'password'" v-model="signup.password"
                            placeholder="Create a strong password" @input="checkStrength(signup.password)" />
                        <button class="eye-btn-signup" @click="togglePw('signup')" type="button">
                            {{ showPw.signup ? '🙈' : '👁' }}
                        </button>
                        <div class="pw-strength">
                            <div class="pw-bar">
                                <div class="pw-fill" :style="{
                                    width: passwordStrength.width,
                                    background: passwordStrength.color
                                }"></div>
                            </div>
                            <span class="pw-label">{{ passwordStrength.text }}</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Gender <span class="required">*</span></label>

                        <div class="gender-toggle">
                            <button type="button" class="gender-btn" :class="{ active: selectedGender === 'M' }"
                                @click="setGender('M')">
                                Male
                            </button>

                            <button type="button" class="gender-btn" :class="{ active: selectedGender === 'F' }"
                                @click="setGender('F')">
                                Female
                            </button>

                        </div>
                        <span v-if="!selectedGender" class="error-text">
                            Please select a gender
                        </span>

                    </div>

                    <div class="checkbox-group">
                        <input type="checkbox" v-model="acceptedTerms" />
                        <label for="signup-terms">I agree to Succour's <router-link to="/terms-of-use"
                                class="auth-link">Terms of
                                Use</router-link> and <router-link to="/privacy-policy" class="auth-link">Privacy
                                Policy</router-link></label>
                    </div>

                    <button class="btn-auth green" @click="handleSignup" :disabled="isSubmitting">
                        {{ isSubmitting ? "Creating account..." : "Create Account" }}
                    </button>

                    <!-- <div class="or-divider">or</div>

                    <button class="btn-google" @click="handleGoogle()">
                        <svg width="18" height="18" viewBox="0 0 24 24">
                            <path fill="#4285F4"
                                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                            <path fill="#34A853"
                                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                            <path fill="#FBBC05"
                                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
                            <path fill="#EA4335"
                                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                        </svg>
                        Sign up with Google
                    </button> -->

                    <p class="auth-footer-text">
                        Already have an account?
                        <a href="#" class="auth-link" @click.prevent="showScreen('login')">Sign in</a>
                    </p>
                </div>

                <!-- ── SCREEN: FORGOT PASSWORD ── -->
                <div class="auth-screen" v-show="currentScreen === 'forgot'">
                    <h2 class="auth-title">Forgot your password?</h2>
                    <p class="auth-subtitle">Enter your email address and we will send you a link to reset your
                        password.</p>

                    <div class="form-group">
                        <label>Email Address <span class="required">*</span></label>
                        <input type="email" id="forgot-email" v-model="forgot.email" placeholder="you@example.com" />
                    </div>

                    <button class="btn-auth green" @click="handleForgot()" :disabled="sendLink"
                        style="margin-bottom:16px;">
                        {{ sendLink ? "Sending..." : "Send Reset Link" }}
                    </button>

                    <p class="auth-footer-text">
                        Remembered it?
                        <a href="#" class="auth-link" @click.prevent="showScreen('login')">Back to Sign In</a>
                    </p>
                </div>

                <!-- ── SCREEN: RESET PASSWORD ── -->
                <div class="auth-screen" v-show="currentScreen === 'reset'">
                    <h2 class="auth-title">Set a new password</h2>
                    <p class="auth-subtitle">Your new password must be different from your previous one.</p>

                    <div class="form-group password-wrap">
                        <label>New Password <span class="required">*</span></label>
                        <input :type="showPw.reset1 ? 'text' : 'password'" v-model="reset.password"
                            placeholder="Create a strong password" @input="checkStrength(reset.password)" />
                        <button class="eye-btn-signup" @click="togglePw('reset1')" type="button">
                            {{ showPw.reset1 ? '🙈' : '👁' }}
                        </button>
                        <div class="pw-strength">
                            <div class="pw-bar">
                                <div class="pw-fill" :style="{
                                    width: passwordStrength.width,
                                    background: passwordStrength.color
                                }"></div>
                            </div>
                            <span class="pw-label">{{ passwordStrength.text }}</span>
                        </div>
                    </div>
                    <div class="form-group password-wrap">
                        <label>Confirm New Password <span class="required">*</span></label>
                        <input :type="showPw.reset2 ? 'text' : 'password'" v-model="reset.confirmPassword"
                            placeholder="Create a strong password" />
                        <button class="eye-btn-signup" @click="togglePw('reset2')" type="button">
                            {{ showPw.reset2 ? '🙈' : '👁' }}
                        </button>

                    </div>

                    <button class="btn-auth green" @click="handleReset" :disabled="isResetPassword"
                        style="margin-top:8px;">
                        {{ isResetPassword ? "Updating..." : "Update Password" }}
                    </button>
                </div>

                <!-- ── SCREEN: VERIFY EMAIL (post signup) ── -->
                <div class="auth-screen" v-show="currentScreen === 'verify'">
                    <div class="auth-success">
                        <div class="success-circle">📧</div>
                        <h3>Check your email</h3>
                        <p>We sent a verification link to <strong id="verify-email-shown"></strong>. Click the link in
                            the email to activate your account.</p>
                        <button class="btn-auth green" @click="showScreen('login')"
                            style="max-width:280px;margin:0 auto 12px;">Back to Sign In</button>
                        <!-- <p style="font-size:.8rem;color:var(--text-light);font-weight:300;">
                            Didn't receive it?
                            <a href="#" class="auth-link" @click="resendVerification();">Resend email</a>
                        </p> -->
                    </div>
                </div>

                <!-- ── SCREEN: PASSWORD RESET SUCCESS ── -->
                <div class="auth-screen" v-show="currentScreen === 'reset-success'">
                    <div class="auth-success">
                        <div class="success-circle">✅</div>
                        <h3>Password updated!</h3>
                        <p>Your password has been changed successfully. You can now sign in with your new password.</p>
                        <button class="btn-auth green" @click="showScreen('login')"
                            style="max-width:280px;margin:0 auto;">Sign In</button>
                    </div>
                </div>

                <!-- ── SCREEN: FORGOT SUCCESS ── -->
                <div class="auth-screen" v-show="currentScreen === 'forgot-success'">
                    <div class="auth-success">
                        <div class="success-circle">📬</div>
                        <h3>Reset link sent!</h3>
                        <p>We sent a password reset link to your email. Check your inbox and follow the instructions.
                        </p>
                        <button class="btn-auth green" @click="showScreen('login')"
                            style="max-width:280px;margin:0 auto 12px;">Back to Sign In</button>
                        <p style="font-size:.8rem;color:var(--text-light);font-weight:300;">
                            Didn't receive it?
                            <a href="#" class="auth-link" @click.prevent="showScreen('forgot')">Try again</a>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { formatErrorMessages } from "@/utils/errorHandler";
import Request from "@/utils/apiclient.js";
import ToastManagerVue from "@/components/ToastAlert/ToastManager.vue";
import statesData from "@/data/states.js";

export default {
    name: "LoginPage",
    components: {
        ToastManagerVue,
    },

    data() {
        return {
            userType: "seeker",
            currentScreen: "login",
            acceptedTerms: false,
            states: statesData.states,
            isVerifyingEmail: false,
            emailVerified: "", // success | failed | already_verified
            isResetPassword: false,
            passwordResetSuccessful: false,
            labels: {
                seeker: {
                    login: ["Welcome back", "Sign in to your Care Seeker account"],
                    signup: ["Create your account", "Join Succour as a Care Seeker"]
                },
                giver: {
                    login: ["Welcome back", "Sign in to your Care Giver account"],
                    signup: ["Create your account", "Join Succour as a Care Giver"]
                }
            },
            toastManager: null,
            isLoggingIn: false,
            isSubmitting: false,
            login: {
                email: "",
                password: "",
            },

            selectedGender: null,

            signup: {
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                state: "",
                gender: "",
                password: "",
                date_of_birth: ""
            },
            sendLink: false,
            forgot: {
                email: "",
            },

            reset: {
                password: "",
                confirmPassword: "",
                Id: "",
                token: ""
            },

            showPw: {
                login: false,
                signup: false,
                reset1: false,
                reset2: false
            },

            passwordStrength: {
                score: 0,
                text: "Enter a password",
                color: "#eee",
                width: "0%",
            }
        };
    },



    computed: {
        currentTitle() {
            return this.labels[this.userType]?.[this.currentScreen]?.[0] || "";
        },
        currentSub() {
            return this.labels[this.userType]?.[this.currentScreen]?.[1] || "";
        }
    },

    methods: {
        setUserType(type) {
            this.userType = type;
        },

        showScreen(name) {
            this.currentScreen = name;
        },

        showToast(msg, statusValue) {
            this.toastManager?.addToast(msg, statusValue);
        },

        togglePw(type) {
            this.showPw[type] = !this.showPw[type];
        },

        checkStrength(pw) {
            let score = 0;

            if (pw.length >= 8) score++;
            if (/[A-Z]/.test(pw)) score++;
            if (/[0-9]/.test(pw)) score++;
            if (/[^A-Za-z0-9]/.test(pw)) score++;

            const texts = ["Too short", "Fair", "Good", "Strong"];
            const colors = ["#F59CAB", "#FF9700", "#8BC34A", "#17865F"];

            this.passwordStrength = {
                score,
                text:
                    pw.length === 0
                        ? "Enter a password"
                        : texts[score - 1] || "Enter a password",
                color: colors[score - 1] || "#eee",
                width: `${score * 25}%`,
            };
        },

        handleLogin() {
            if (this.isLoggingIn) return;
            this.isLoggingIn = true;

            const formData = {
                email: this.login.email,
                password: this.login.password,
            };

            const request = new Request("/auth/login/");
            const rawData = JSON.stringify(formData);

            console.log("raw data", rawData);

            request.post(rawData, (data, error) => {
                this.isLoggingIn = false;

                if (error) {
                    console.log("data error", error);

                    if (error.status === "failure") {
                        return this.showToast(error.message, "error");
                    }

                    if (error.detail) {
                        return this.showToast("Incorrect Email or Password", "error");
                    }

                    const errorMessages = formatErrorMessages(error);
                    console.log("error", errorMessages);

                    errorMessages.forEach((message) =>
                        this.showToast(message, "error")
                    );
                } else {
                    console.log("Success data here:", data);

                    localStorage.setItem("_user", data.data.tokens.access);
                    localStorage.setItem("_userRefresh", data.data.tokens.refresh);
                    localStorage.setItem(
                        "_userProfile",
                        JSON.stringify(data.data.user)
                    );

                    this.showToast("Login Successful", "success");

                    setTimeout(() => {
                        const user = data.data.user;

                        if (user.type === "Care seeker" && this.userType === "seeker") {
                            const { has_onboarded, care_seeker, is_insurance } = user;

                            if (is_insurance) {
                                if (care_seeker?.staffs.length > 0) {
                                    return this.$router.push("/careseeker");
                                } else {
                                    return this.$router.push("/careseeker/onboardingcshi");
                                }
                            }

                            if (has_onboarded) {
                                return this.$router.push("/careseeker");
                            }

                            if (!has_onboarded) {
                                if (!care_seeker || Object.keys(care_seeker).length === 0) {
                                    return this.$router.push("/careseeker-onboarding");
                                }

                                const onboardingRoutes = {
                                    Onboarding: "careseeker-onboarding/job-post/step-1",
                                };

                                const route =
                                    onboardingRoutes[care_seeker.onboarding_status];

                                if (route) {
                                    return this.$router.push(route);
                                }
                            }
                        } else if (user.type === "Care giver" && this.userType === "giver") {
                            const { has_onboarded, care_giver } = user;

                            if (has_onboarded) {
                                return this.$router.push("/caregiver");
                            }

                            if (!has_onboarded) {
                                if (!care_giver || Object.keys(care_giver).length === 0) {
                                    return this.$router.push("/caregiver-onboarding");
                                }

                                const onboardingRoutes = {
                                    Onboarding:
                                        "/caregiver-onboarding/build-profile/step-2",
                                    Availability:
                                        "/caregiver-onboarding/build-profile/step-3",
                                    Profile:
                                        "/caregiver-onboarding/complete-verification/step-2",
                                    Verification:
                                        "/caregiver-onboarding/complete-verification/step-2",
                                };

                                const route =
                                    onboardingRoutes[care_giver.onboarding_status];

                                if (route) {
                                    return this.$router.push(route);
                                }
                            }
                        } else if (user.type === "Admin") {
                            this.$router.push("/admin");
                        }
                    }, 100);
                }
            });
        },

        handleForgot() {
            if (this.sendLink) return;

            this.sendLink = true;

            console.log("Email:", this.forgot.email);

            const payload = {
                email: this.forgot.email,
            };

            if (!this.forgot.email) {
                this.showToast("Email is required", "error");
                this.sendLink = false;
                return;
            }


            const rawData = JSON.stringify(payload);
            const request = new Request("/auth/password-reset/");

            request.post(rawData, (data, error) => {
                if (error) {
                    console.log("data error", error);

                    this.sendLink = false; // ✅ important: reset on error

                    if (error.status === "failure") {
                        return this.showToast(error.message, "error");
                    }

                    if (error.detail) {
                        return this.showToast("An error occurred", "error");
                    }

                    const errorMessages = formatErrorMessages(error);
                    console.log("error", errorMessages);

                    errorMessages.forEach((message) =>
                        this.showToast(message, "error")
                    );
                } else {
                    console.log("data", data);

                    this.sendLink = false;

                    this.showToast(
                        "Check your email for reset password instructions",
                        "success"
                    );

                    this.showScreen("forgot-success");

                    // this.$router.push("/reset-password");
                }
            });

        },

        handleReset() {
            if (this.isResetPassword) return;

            if (this.reset.password !== this.reset.confirmPassword) {
                this.showToast("Passwords do not match", "error");
                return;
            }

            if (!this.reset.password) {
                this.showToast("Password is required", "error");
                this.isResetPassword = false;
                return;
            }

            if (!this.reset.confirmPassword) {
                this.showToast("Confirm Password is required", "error");
                this.isResetPassword = false;
                return;
            }


            this.isResetPassword = true;

            const payload = {
                new_password: this.reset.password,
                confirm_password: this.reset.confirmPassword,
            };

            const rawData = JSON.stringify(payload);

            const request = new Request(
                `/auth/password-reset/confirm/${this.reset.Id}/${this.reset.token}/`
            );

            console.log(request)

            request.post(rawData, (data, error) => {
                if (error) {
                    console.log("data error", error);

                    if (error.status === "failure") {
                        return this.showToast(error.message, "error");
                    }

                    if (error.detail) {
                        return this.showToast("An error occurred", "error");
                    }

                    const errorMessages = formatErrorMessages(error);

                    errorMessages.forEach((message) =>
                        this.showToast(message, "error")
                    );
                } else {
                    console.log("data", data);

                    this.passwordResetSuccessful = true;

                    //   this.showToast(
                    //     "Check your email for reset password instructions",
                    //     "success"
                    //   );

                    this.showScreen("reset-success");
                }

                this.isResetPassword = false;
            });
        },


        redirectToHome() {
            this.$router.push("/");
        },

        routeToCaregiver() {
            this.showRegScreen = true;
            this.caretype = "Care giver";
        },

        routeToCareseeker() {
            this.showRegScreen = true;
            this.caretype = "Care seeker";
        },

        updateFieldValue(field) {
            if (field.id === "phone") {
                field.value = field.value.replace(/\s+/g, "").trim();
            } else {
                field.value = field.value.trim();
            }
        },

        setGender(gender) {
            this.selectedGender = gender;
        },
        isValidPhoneNumber(number) {
            return /^\d{1,11}$/.test(number);
        },

        isValidEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },

        isValidDate(date) {
            const today = new Date();
            const birthDate = new Date(date);

            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();

            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age >= 18;
        },

        verifyEmail(token) {
            console.log(token);
            if (!token) return;

            this.isVerifyingEmail = true;

            const request = new Request(`/user/verify_email/?token=${token}`);

            request.get((res, error) => {
                this.isVerifyingEmail = false;

                if (error) {
                    console.error("Verification error:", error);

                    if (error.message === "Email already verified.") {
                        this.emailVerified = "already_verified";
                        this.showToast("Email already verified. Please login.", "success");
                    } else {
                        this.emailVerified = "failed";
                        this.showToast("Verification failed or link expired", "error");
                    }

                    this.showScreen("login");
                } else {
                    console.log("Verification success:", res);

                    this.emailVerified = "success";
                    this.showToast("Email verified successfully. Please login.", "success");

                    setTimeout(() => {
                        this.showScreen("login");
                    }, 2000);
                }
            });
        },


        handleSignup() {
            if (this.isSubmitting) return;

            this.isSubmitting = true;

            const {
                first_name,
                last_name,
                email,
                phone,
                state,
                password,
                date_of_birth,
            } = this.signup;

            // ✅ Trim inputs
            const trimmedFirstName = first_name?.trim();
            const trimmedLastName = last_name?.trim();
            const trimmedEmail = email?.trim();
            const trimmedPhone = phone?.replace(/\s+/g, "").trim();

            // =========================
            // 🔴 VALIDATIONS START HERE
            // =========================

            if (!trimmedFirstName) {
                this.showToast("First name is required", "error");
                this.isSubmitting = false;
                return;
            }

            if (!trimmedLastName) {
                this.showToast("Last name is required", "error");
                this.isSubmitting = false;
                return;
            }

            if (!trimmedEmail) {
                this.showToast("Email is required", "error");
                this.isSubmitting = false;
                return;
            }

            if (!this.isValidEmail(trimmedEmail)) {
                this.showToast("Enter a valid email address", "error");
                this.isSubmitting = false;
                return;
            }

            if (!trimmedPhone) {
                this.showToast("Phone number is required", "error");
                this.isSubmitting = false;
                return;
            }

            if (!this.isValidPhoneNumber(trimmedPhone)) {
                this.showToast("Enter a valid phone number (max 11 digits)", "error");
                this.isSubmitting = false;
                return;
            }

            if (!state) {
                this.showToast("Please select your state", "error");
                this.isSubmitting = false;
                return;
            }

            if (!date_of_birth) {
                this.showToast("Date of birth is required", "error");
                this.isSubmitting = false;
                return;
            }

            if (!this.isValidDate(date_of_birth)) {
                this.showToast("You must be at least 18 years old", "error");
                this.isSubmitting = false;
                return;
            }

            if (!password) {
                this.showToast("Password is required", "error");
                this.isSubmitting = false;
                return;
            }

            if (password.length < 8) {
                this.showToast("Password must be at least 8 characters", "error");
                this.isSubmitting = false;
                return;
            }

            if (!this.selectedGender) {
                this.showToast("Select a gender", "error");
                this.isSubmitting = false;
                return;
            }

            // Optional: Terms checkbox validation
            if (!this.acceptedTerms) {
                this.showToast("You must agree to the terms and policy", "error");
                this.isSubmitting = false;
                return;
            }


            // =========================
            // ✅ BUILD FINAL DATA
            // =========================

            const formData = {
                first_name: trimmedFirstName,
                last_name: trimmedLastName,
                email: trimmedEmail,
                phone: trimmedPhone,
                state,
                password,
                date_of_birth,
                type: this.userType === "seeker" ? "Care seeker" : "Care giver",
                gender: this.selectedGender,
                is_insurance: this.isCSInsurance === "true",
            };

            const request = new Request("/user/");
            const rawData = JSON.stringify(formData);

            console.log(rawData);

            request.post(rawData, (data, error) => {
                this.isSubmitting = false;

                if (error) {
                    const errorMessages = formatErrorMessages(error);
                    errorMessages.forEach((msg) => this.showToast(msg, "error"));
                } else {
                    this.showToast(
                        `Please verify your account through your email ${trimmedEmail}`,
                        "success"
                    );

                    this.currentScreen = "verify";

                    sessionStorage.removeItem("isCSInsurance");
                    localStorage.clear();

                    setTimeout(() => {
                        this.$router.push("/login");
                    }, 3000);
                }
            });
        },

        handleGoogle() {

        }
    },

    mounted() {
        document.title = "Succour® Sign In";
        this.toastManager = this.$refs.toastManager;


        const { token } = this.$route.query;

        console.log(token);
        console.log(this.$route.path)

        // ✅ EMAIL VERIFY
        if (this.$route.path === "/verify_email/" && token) {
            console.log(this.$route.path);
            console.log(token)
            this.verifyEmail(token);
        }

        // ✅ RESET PASSWORD
        if (this.$route.name === "ResetPassword") {
            const { Id, token } = this.$route.params;

            if (Id && token) {
                this.reset.Id = Id;
                this.reset.token = token;
                this.currentScreen = "reset";
            } else {
                this.showToast("Invalid reset link", "error");
                this.currentScreen = "login";
            }
        }
        const hash = window.location.hash.replace("#", "");
        const valid = ["login", "signup", "forgot", "reset", "forgot-success", "reset-success", "verify"];

        if (valid.includes(hash)) {
            this.currentScreen = hash;
        }

        sessionStorage.clear();
        localStorage.clear();
    }
};
</script>

<style lang="css" scoped>
:root {
    --pink: #F59CAB;
    --pink-light: #FDE8EC;
    --pink-mid: #F8C4CC;
    --green: #17865F;
    --green-dark: #0f5c41;
    --green-light: #E8F5EF;
    --cream: #FDF9F7;
    --orange: #FF9700;
    --text-dark: #1C2B27;
    --text-mid: #4A5E58;
    --text-light: #8A9E98;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'Open Sans', sans-serif;
    background: var(--cream);
    color: var(--text-dark);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

/* Layout */
.auth-wrapper {
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 100vh;
}

/* Left panel brand */
.auth-brand {
    background: var(--green);
    padding: 48px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
}

.auth-brand::before {
    content: '';
    position: absolute;
    top: -80px;
    right: -80px;
    width: 360px;
    height: 360px;
    background: rgba(255, 255, 255, .05);
    border-radius: 50%;
}

.auth-brand::after {
    content: '';
    position: absolute;
    bottom: -60px;
    left: -40px;
    width: 260px;
    height: 260px;
    background: rgba(245, 156, 171, .08);
    border-radius: 50%;
}

.brand-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    position: relative;
    z-index: 2;
}

.brand-logo span {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
}

.brand-logo sup {
    font-size: .5rem;
    color: rgba(255, 255, 255, .5);
}

.brand-body {
    position: relative;
    z-index: 2;
}

.brand-body h2 {
    font-family: 'Lora', serif;
    font-size: 2rem;
    font-weight: 400;
    color: white;
    line-height: 1.25;
    margin-bottom: 16px;
}

.brand-body h2 em {
    font-style: italic;
    color: var(--pink);
}

.brand-body p {
    color: rgba(255, 255, 255, .65);
    font-size: .9rem;
    line-height: 1.75;
    font-weight: 300;
    max-width: 320px;
}

.brand-features {
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: relative;
    z-index: 2;
}

.brand-feat {
    display: flex;
    align-items: center;
    gap: 12px;
}

.brand-feat-icon {
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, .12);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .9rem;
    flex-shrink: 0;
}

.brand-feat span {
    font-size: .82rem;
    color: rgba(255, 255, 255, .7);
    font-weight: 300;
}

/* Right panel form */
.auth-form-panel {
    background: white;
    padding: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
}

.auth-form-inner {
    width: 100%;
    max-width: 400px;
}

/* Screen visibility */
.auth-screen {
    width: 100%;
}

.auth-screen.active {
    display: block;
}

/* User type toggle */
.user-toggle {
    display: flex;
    background: var(--cream);
    border-radius: 100px;
    padding: 4px;
    margin-bottom: 32px;
    gap: 4px;
}

.toggle-btn {
    flex: 1;
    padding: 10px 16px;
    border: none;
    border-radius: 100px;
    font-family: 'Open Sans', sans-serif;
    font-size: .82rem;
    font-weight: 600;
    cursor: pointer;
    background: transparent;
    color: var(--text-mid);
    transition: all .2s;
}

.toggle-btn.active {
    background: white;
    color: var(--text-dark);
    box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
}

/* Form styles */
.auth-title {
    font-family: 'Lora', serif;
    font-size: 1.6rem;
    font-weight: 400;
    color: var(--text-dark);
    margin-bottom: 6px;
}

.auth-subtitle {
    font-size: .84rem;
    color: var(--text-mid);
    font-weight: 300;
    margin-bottom: 28px;
    line-height: 1.6;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 16px;
}

.form-group label {
    font-size: .74rem;
    font-weight: 700;
    color: var(--text-mid);
    letter-spacing: .06em;
    text-transform: uppercase;
}

.form-group input,
.form-group select {
    font-family: 'Open Sans', sans-serif;
    font-size: .88rem;
    color: var(--text-dark);
    background: var(--cream);
    border: 1.5px solid rgba(245, 156, 171, .3);
    border-radius: 10px;
    padding: 12px 14px;
    outline: none;
    transition: border-color .2s, box-shadow .2s;
    width: 100%;
}

.form-group input:focus,
.form-group select:focus {
    border-color: var(--green);
    box-shadow: 0 0 0 3px rgba(23, 134, 95, .08);
    background: white;
}

.form-group.password-wrap {
    position: relative;
}

.form-group.password-wrap input {
    padding-right: 44px;
}

.gender-toggle {
    display: flex;
    gap: 8px;
}

.gender-btn {
    flex: 1;
    padding: 12px;
    border-radius: 10px;
    border: 1.5px solid rgba(245, 156, 171, .3);
    background: var(--cream);
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    font-weight: 600;
    color: var(--text-mid);
    cursor: pointer;
    transition: all .2s;
}

.gender-btn:hover {
    background: white;
}

.gender-btn.active {
    border-color: var(--green);
    background: white;
    color: var(--text-dark);
    box-shadow: 0 0 0 3px rgba(23, 134, 95, .08);
}

.eye-btn {
    position: absolute;
    right: 12px;
    bottom: 12px;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--text-light);
    font-size: 1rem;
    padding: 2px;
}

.eye-btn-signup {
    position: absolute;
    top: 0;
    right: 12px;
    bottom: 12px;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--text-light);
    font-size: 1rem;
    padding: 2px;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.required {
    color: var(--pink);
    margin-left: 2px;
}

/* Divider */
.or-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 20px 0;
    color: var(--text-light);
    font-size: .78rem;
}

.or-divider::before,
.or-divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(0, 0, 0, .08);
}

/* Buttons */
.btn-auth {
    width: 100%;
    padding: 13px;
    border-radius: 100px;
    border: none;
    font-family: 'Open Sans', sans-serif;
    font-size: .9rem;
    font-weight: 700;
    cursor: pointer;
    transition: background .2s, transform .15s;
}

.btn-auth:hover {
    transform: translateY(-1px);
}

.btn-auth.green {
    background: var(--green);
    color: white;
}

.btn-auth.green:hover {
    background: var(--green-dark);
}

.btn-auth.pink {
    background: var(--pink);
    color: white;
}

.btn-auth.pink:hover {
    background: #e8849a;
}

.btn-google {
    width: 100%;
    padding: 12px;
    border-radius: 100px;
    border: 1.5px solid rgba(0, 0, 0, .12);
    background: white;
    font-family: 'Open Sans', sans-serif;
    font-size: .88rem;
    font-weight: 600;
    color: var(--text-dark);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: background .2s, border-color .2s;
}

.btn-google:hover {
    background: var(--cream);
    border-color: rgba(0, 0, 0, .2);
}

button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Links */
.auth-link {
    color: var(--green);
    font-weight: 600;
    text-decoration: none;
    font-size: .84rem;
}

.logo-img {
    width: 30%;
    object-fit: contain;
}

.auth-link:hover {
    text-decoration: underline;
}

.auth-footer-text {
    font-size: .82rem;
    color: var(--text-mid);
    margin-top: 20px;
    text-align: center;
    font-weight: 300;
}

.forgot-link {
    text-align: right;
    margin-top: -8px;
    margin-bottom: 16px;
}

/* Password strength */
.pw-strength {
    margin-top: 6px;
}

.pw-bar {
    height: 4px;
    border-radius: 2px;
    background: rgba(0, 0, 0, .08);
    overflow: hidden;
    margin-bottom: 4px;
}

.pw-fill {
    height: 100%;
    width: 0%;
    border-radius: 2px;
    transition: width 0.3s ease, background 0.3s ease;

}

.pw-label {
    font-size: .72rem;
    color: var(--text-light);
}

/* Terms checkbox */
.checkbox-group {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 18px;
}

.checkbox-group input {
    width: 16px;
    height: 16px;
    margin-top: 2px;
    accent-color: var(--green);
    flex-shrink: 0;
    cursor: pointer;
}

.checkbox-group label {
    font-size: .8rem;
    color: var(--text-mid);
    font-weight: 300;
    line-height: 1.5;
    cursor: pointer;
}

/* Success / info states */
.auth-success {
    text-align: center;
    padding: 20px 0;
}

.success-circle {
    width: 68px;
    height: 68px;
    background: var(--green-light);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    margin: 0 auto 16px;
}

.auth-success h3 {
    font-family: 'Lora', serif;
    font-size: 1.3rem;
    font-weight: 400;
    margin-bottom: 8px;
}

.auth-success p {
    font-size: .84rem;
    color: var(--text-mid);
    font-weight: 300;
    line-height: 1.7;
    margin-bottom: 20px;
}

/* Back link */
.back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: .82rem;
    color: var(--text-mid);
    text-decoration: none;
    margin-bottom: 24px;
    font-weight: 600;
    transition: color .2s;
}

.back-link:hover {
    color: var(--green);
}

.error-text {
    font-size: .72rem;
    color: red;
    margin-top: 4px;
}

/* Responsive */
@media(max-width:1024px) {
    .auth-wrapper {
        grid-template-columns: 1fr 1fr;
    }

    .auth-brand {
        padding: 36px;
    }

    .brand-body h2 {
        font-size: 1.6rem;
    }
}

@media(max-width:768px) {
    .auth-wrapper {
        grid-template-columns: 1fr;
    }

    .auth-brand {
        display: none;
    }

    .auth-form-panel {
        padding: 36px 24px;
    }
}

@media(max-width:480px) {
    .form-row {
        grid-template-columns: 1fr;
    }

    .auth-form-panel {
        padding: 28px 18px;
    }
}
</style>